import React from "react";
import MainPage from "./components/Pages/MainPage";
import "./App.css";

function App() {
  return <MainPage />;
}

export default App;
